import React, { type ComponentProps } from 'react';

import { type SizeType } from '../../features/config';

import { type BreadcrumbItem, useBreadcrumb } from './Breadcrumb.context';
import * as Primitives from './Breadcrumb.parts';

export type BreadcrumbProps = {
    items: BreadcrumbItem[];
    className?: string;
    size?: SizeType;
    visibleItemsAmount?: number;
    minVisibleItemsAmount?: number;
} & Omit<ComponentProps<typeof Primitives.Root>, 'breadcrumb'>;

const BreadcrumbRoot = ({
    className,
    items,
    size,
    visibleItemsAmount,
    minVisibleItemsAmount = 1,
    ...rest
}: BreadcrumbProps) => {
    const breadcrumb = useBreadcrumb({
        items,
        size,
        visibleItemsAmount,
        minVisibleItemsAmount
    });
    return (
        <Primitives.Root breadcrumb={breadcrumb} className={className} {...rest}>
            <Primitives.Items>
                <Primitives.Rest />
                {breadcrumb.items.map((item) => (
                    <Primitives.Item key={item.id} item={item} />
                ))}
            </Primitives.Items>
        </Primitives.Root>
    );
};

type BreadcrumbCompound = typeof BreadcrumbRoot & typeof Primitives;

export const Breadcrumb = Object.assign(BreadcrumbRoot, Primitives) as BreadcrumbCompound;
